/**
 * PlatformDot — pastille d'identite plateforme (P/I/E/T).
 *
 * Lettre dans un cercle encre. Pas de couleurs corporate (palette sgraphic
 * = encre + rouge + papier). Differenciation par lettre + tooltip + (a
 * terme) icone monochrome.
 *
 *   <PlatformDot platform="etsy" />
 *   <PlatformDot platform="pinterest" size="sm" />
 */

import './PlatformDot.css'

export type Platform = 'pinterest' | 'instagram' | 'etsy' | 'tiktok' | 'saatchi' | 'artfinder'

const PLATFORM_LETTERS: Record<Platform, string> = {
  pinterest: 'P',
  instagram: 'I',
  etsy: 'E',
  tiktok: 'T',
  saatchi: 'S',
  artfinder: 'A',
}

const PLATFORM_LABELS: Record<Platform, string> = {
  pinterest: 'Pinterest',
  instagram: 'Instagram',
  etsy: 'Etsy',
  tiktok: 'TikTok',
  saatchi: 'Saatchi',
  artfinder: 'Artfinder',
}

interface PlatformDotProps {
  platform: Platform
  size?: 'sm' | 'md'
}

export default function PlatformDot({ platform, size = 'md' }: PlatformDotProps) {
  const sizeClass = size === 'sm' ? 'platform-dot-sm' : ''
  const classes = ['platform-dot', `ui-platform-dot--${platform.charAt(0)}`, sizeClass]
    .filter(Boolean)
    .join(' ')
  return (
    <span
      className={classes}
      role="img"
      aria-label={PLATFORM_LABELS[platform]}
      title={PLATFORM_LABELS[platform]}
    >
      {PLATFORM_LETTERS[platform]}
    </span>
  )
}
